/**
 * Service de mock pour simuler les API pendant le développement local
 * Cela évite les problèmes de CORS et permet de développer même sans connexion
 */

/**
 * Produits Shopify mockés pour le développement
 */
export const mockShopifyProducts = [
  {
    id: 'mock-product-1',
    title: 'Mock Product 1',
    description: 'This is a mock product for development',
    price: '99.99',
    status: 'active',
    vendor: 'Mock Vendor',
    product_type: 'Development',
    tags: ['mock', 'development'],
    variants: [
      {
        id: 'mock-variant-1',
        price: '99.99',
        inventory_quantity: 10,
        sku: 'MOCK-SKU-1'
      }
    ],
    images: [
      {
        src: 'https://via.placeholder.com/500x500.png?text=Mock+Product+1'
      }
    ]
  },
  {
    id: 'mock-product-2',
    title: 'Mock Product 2',
    description: 'Another mock product for testing',
    price: '49.99',
    status: 'active',
    vendor: 'Mock Vendor',
    product_type: 'Testing',
    tags: ['mock', 'testing'],
    variants: [
      {
        id: 'mock-variant-2',
        price: '49.99',
        inventory_quantity: 5,
        sku: 'MOCK-SKU-2'
      }
    ],
    images: [
      {
        src: 'https://via.placeholder.com/500x500.png?text=Mock+Product+2'
      }
    ]
  },
  {
    id: 'mock-product-3',
    title: 'Mock Product 3 (Premium)',
    description: 'A premium mock product with detailed description for testing the display of long text in the user interface.',
    price: '199.99',
    status: 'active',
    vendor: 'Premium Mocks',
    product_type: 'Premium',
    tags: ['mock', 'premium', 'featured'],
    variants: [
      {
        id: 'mock-variant-3',
        price: '199.99',
        inventory_quantity: 3,
        sku: 'PREMIUM-SKU-3'
      }
    ],
    images: [
      {
        src: 'https://via.placeholder.com/500x500.png?text=Premium+Mock'
      }
    ]
  }
];

/**
 * Produits PrestaShop mockés pour le développement
 */
export const mockPrestaShopProducts = [
  {
    id: 1,
    name: 'PrestaShop Test Product 1',
    description: 'A mock PrestaShop product for development purposes',
    price: 89.99,
    reference: 'PS-DEV-001',
    quantity: 15,
    active: true,
    categories: [2, 5],
    images: ['https://via.placeholder.com/500x500.png?text=PrestaShop+Product+1']
  },
  {
    id: 2,
    name: 'PrestaShop Test Product 2',
    description: 'Another mock PrestaShop product for testing',
    price: 59.99,
    reference: 'PS-DEV-002',
    quantity: 8,
    active: true,
    categories: [2],
    images: ['https://via.placeholder.com/500x500.png?text=PrestaShop+Product+2']
  }
];

/**
 * Détermine si l'application est en mode développement
 */
export const isDevelopmentMode = (): boolean => {
  // Liste des domaines de production
  const productionDomains = [
    'botmaker-agency.ai',
    'api.botmaker-agency.ai',
    'widget.botmaker-agency.ai',
    'app.botmaker-agency.ai'
  ];
  
  // Vérifier si nous sommes sur un domaine de production
  const currentDomain = window.location.hostname;
  const isProductionDomain = productionDomains.some(domain => 
    currentDomain === domain || currentDomain.endsWith('.' + domain)
  );
  
  // Valeurs de débogage pour comprendre la décision
  const devModeEnv = import.meta.env.VITE_DEV_MODE === 'true';
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  console.log('DEBUG isDevelopmentMode:', {
    currentDomain,
    isProductionDomain,
    devModeEnv,
    isLocalhost,
    mode: import.meta.env.MODE
  });
  
  // Si nous sommes sur un domaine de production, jamais retourner le mode développement
  if (isProductionDomain) {
    return false;
  }
  
  // Sinon, appliquer la logique standard
  return devModeEnv || isLocalhost;
};

/**
 * Simule un délai réseau pour les appels API (uniquement en développement)
 */
export const simulateNetworkDelay = async (minMs = 200, maxMs = 800): Promise<void> => {
  if (!isDevelopmentMode()) return;
  
  const delay = Math.floor(Math.random() * (maxMs - minMs)) + minMs;
  await new Promise(resolve => setTimeout(resolve, delay));
}; 